import { secondaryCategoryRepository } from '@webapp/core/data-access/repositories/SecondaryCategoryRepository/'
import { type PaginationParams } from '@webapp/core/providers/Pagination/pagination.types'
import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { type RepoFilterParams } from '@webapp/infrastructure/interfaces/repositories/RepoFilterParams'

const base = ['secondaryCategories']

export const secondaryCategoryQueryConfig = {
  // ['secondaryCategories', 'detail', id]
  getById: (secondaryCategoryId: number) => ({
    queryKey: buildQueryKey([...base, 'detail', secondaryCategoryId]),
    queryFn: () => secondaryCategoryRepository.getById(secondaryCategoryId),
  }),

  getSecondaryCategoryPermissions: (
    params?: RepoFilterParams,
    paginationParams?: PaginationParams
  ) => {
    const mergedParams = { ...paginationParams, ...params }
    return {
      queryKey: buildQueryKey([
        ...base,
        'secondary-category-list',
        mergedParams,
      ]),
      queryFn: () => {
        if (!params?.permission || !params?.user) {
          throw new Error(
            'Missing required parameters for getSecondaryCategoryPermissions query. Ensure user and permission are defined.'
          )
        }

        return secondaryCategoryRepository.list(mergedParams)
      },
    }
  },
}
